var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('RefreshPage'),_c('div',{attrs:{"id":"app","data-app":""}},[_c('AppLayout',[_c('router-view'),(_vm.showVersion)?_c('div',{staticClass:"app-version-preview"},[_vm._v(" "+_vm._s(_vm.currentAppVersion ? `Wersja aplikacji: ${_vm.currentAppVersion}` : 'Brak lokalnej wersji aplikacji')+" ")]):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }